
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"50.181","height":"50.182","viewBox":"0 0 50.181 50.182"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"close-grey","transform":"translate(-1315.624 -61.123)"}},[_c('line',{attrs:{"id":"Line_199","data-name":"Line 199","x1":"24.726","y1":"34.466","transform":"translate(1356.059 71.572) rotate(82)","fill":"none","stroke":"#666","stroke-linecap":"round","stroke-width":"8"}}),_c('line',{attrs:{"id":"Line_200","data-name":"Line 200","x1":"24.726","y1":"34.466","transform":"translate(1326.072 70.869) rotate(-8)","fill":"none","stroke":"#666","stroke-linecap":"round","stroke-width":"8"}})])])
          )
        }
      }
    